<template>
  <cy-drawer title="详情" v-model="visible" :loading="loading" @cancel="cancel" @confirm="submit('form')">
    <a-form-model>
      <a-form-model-item>
        <a-row :gutter="10">
          <a-col :lg="8">
            <a-card hoverable>
              <a-card-meta :title="$t('分享数')">
                <template slot="description">
                  {{ form.shareNum }}
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
          <a-col :lg="8">
            <a-card hoverable>
              <a-card-meta :title="$t('收藏数')">
                <template slot="description">
                  {{ form.collectNum }}
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
          <a-col :lg="8">
            <a-card hoverable>
              <a-card-meta :title="$t('评论数')">
                <template slot="description">
                  {{ form.commentCount }}
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
        </a-row>
      </a-form-model-item>
      <a-form-model-item>
        <a-alert :message="$t('菜谱信息')" type="success" />
      </a-form-model-item>
      <a-form-model-item>
        <a-descriptions layout="vertical" bordered>
          <a-descriptions-item :label="$t('封面图')">
            <div v-viewer>
              <img style="width: 50px;height: 50px;" :src="form.mainImg" />
            </div>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('菜谱标题')">
            {{ form.title }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('菜谱内容')">
            <ellipsis :length="60" tooltip>
              {{ form.content }}
            </ellipsis>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('所属分类名称')">
            <ellipsis :length="60" tooltip>
              {{ form.classifyName }}
            </ellipsis>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('难易程度')">
            <ellipsis :length="60" tooltip>
              {{ form.level }}
            </ellipsis>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('主料')">
            <div v-for="(item,index) in form.ingredients" :key="index">
              {{ item.name }}-{{ item.content }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('辅料')">
            <div v-for="(item,index) in form.excipients" :key="index">
              {{ item.name }}-{{ item.content }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('调料')">
            <div v-for="(item,index) in form.condiment" :key="index">
              {{ item.name }}-{{ item.content }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('步骤')">
            <div class="flex align-center" style="margin-bottom: 10px;" v-for="(item,index) in form.stepAddParamList" :key="index">

              <div v-viewer v-if="item.img" style="margin-right: 10px;">
                <img style="width: 50px;height: 50px;" :src="item.img" alt="">
              </div>
              <span style="margin-right: 10px;word-break: break-word;">{{ $t('步骤') }}{{ index+1 }} {{ item.content }}</span>

            </div>
          </a-descriptions-item>
        </a-descriptions>

      </a-form-model-item>
      <a-tabs v-model="active">
        <a-tab-pane key="comments-list" :tab="$t('评论列表')">
        </a-tab-pane>
      </a-tabs>
      <component :is="active" :is-header="false" :bookId="form.id"></component>
    </a-form-model>

  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj } from '../api'
import { fetchList } from '@/views/program/repice-category/api'
import { Ellipsis } from '@/components'
import CommentsList from '@/views/program/comments-list'
export default {
  // 组件名称
  name: 'CreateForm',
  // 过滤器
  filters: {},
  // 组件
  components: {
    CyDrawer,
    FileUpload: () => import('@/components/FileUpload/index2'),
    Ellipsis,
    CommentsList
  },
  // props类型
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  // 数据

  data() {
    return {
      active: 'comments-list',
      visible: false,
      loading: false,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      URL: process.env.VUE_APP_API_BASE_URL + '/api/common/upload',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      imgList: [],
      form: {
        'classifyId': undefined,
        'condiment': [
          { name: '', content: '' }
        ],
        'content': '',
        'excipients': [
          { name: '', content: '' }
        ],
        'id': 0,
        'ingredients': [
          { name: '', content: '' }
        ],
        'level': 1,
        'mainImg': '',
        'remark': '',
        'stepAddParamList': [
          {
            'content': '',
            'img': '',
            'remark': '',
            'sort': 0
          }
        ],
        'summarized': '',
        'title': ''
      },
      rules: {
        classifyId: [{ required: true, message: this.$t('请选择') }],
        title: [{ required: true, message: this.$t('请输入') }],
        mainImg: [{ required: true, message: this.$t('请上传封面图') }],
        content: [{ required: true, message: this.$t('请输入菜谱描述') }]
      },
      editFlag: true,
      select: {
        provinceId: null,
        cityId: null,
        areaId: null
      },
      fenleiList: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['roleList'])
  },
  // 计算属性监听
  watch: {},
  // 创建时
  created() {
    this.getFenleiList()
  },
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    getFenleiList() {
      fetchList({ pageNum: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        console.log(res)
        this.fenleiList = res.data.records
      })
    },
    handleDel(key, index) {
      this.form[key].splice(index, 1)
    },
    handleAdd(key, obj) {
      this.form[key].push(JSON.parse(JSON.stringify(obj)))
    },
    uploadChange(key, e) {
      this.form[key] = e ? e.url : undefined
    },
    handleSetpUpload(index, e) {
      this.form.stepAddParamList[index].img = e ? e.url : undefined
    },
    editorChange(e) {
      console.log(e)
      if (e === '<p><br></p>') {
        this.form.content = ''
      } else {
        this.form.content = e
      }
    },
    handleUploadChange(values) {
      console.log(values)
      this.form.iamTypeNum = values.length > 1 ? 2 : 1
      this.form.iamgePaths = values.map((item) => item.shortcutUrl).join(',')
    },
    del(index) {
      this.form.propDrops.splice(index, 1)
    },
    addDomain() {
      const obj = {
        propNum: undefined,
        num: 0,
        infeRate: 0
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.propDrops.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    init(id) {
      if (id) this.form.id = id
      this.visible = true
      this.$nextTick(() => {
        console.log(this.$refs)

        if (id) {
          this.loading = true
          getObj(this.form.id).then((res) => {
            const keyArr = ['condiment', 'excipients', 'ingredients']
            this.form = res.data
            for (const key in this.form) {
              if (keyArr.includes(key)) {
                this.form[key] = JSON.parse(this.form[key])
              }
            }
            this.form.stepAddParamList = this.form.stepResultList

            console.log(this.form)
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$refs.upload.init('', 200, 200)
        }
      })
    },
    cancel() {
      this.visible = false
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          const keyArr = ['condiment', 'excipients', 'ingredients']
          for (const key in this.form) {
            if (keyArr.includes(key)) {
              this.form[key] = JSON.stringify(this.form[key])
            }
          }
          console.log(this.form)
          if (this.form.id) {
            putObj({ ...this.form })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            addObj({ ...this.form })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handlecoverPicList(e) {
      console.log(e)
      if (e.length > 0) {
        this.form.avatar = e[0].url
      }
    },
    change() {},
    selected(e) {
      console.log(e)
      this.form.province = e.province.value
      this.form.city = e.city.value
      this.form.area = e.area.value
    }
  }
}
</script>

<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.daoju {
  position: relative;
  .del {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
